import NavBar from "../../components/NavBar";
import SectionIniciaProcesso from "../../components/Section/SectionIniciaProcesso";



const NovoProcesso = () => {

    return (
        <main>
            <NavBar />

            <SectionIniciaProcesso />
        </main>
    );
}

export default NovoProcesso;


